// src/config/titleConfig.ts

/**
 * Configuration for page titles and meta descriptions
 */
const titleConfig = {
  siteName: 'Hoptira',
  titleSuffix: '| Hoptira',
  pages: {
    '/': {
      title: 'Home',
      description:
        'A digital agency that simplifies web, apps, analytics, ai, and automation',
    },
    '/about': {
      title: 'About Us',
      description:
        'Learn more about Hoptira and our mission to simplify digital solutions',
    },
    '/team': {
      title: 'The Team',
      description:
        'The team behind Hoptira, dedicated to delivering exceptional digital solutions',
    },
    '/services': {
      title: 'Our Services',
      description:
        'Explore our web, app, analytics, AI, and automation services',
    },
    '/faq': {
      title: 'FAQ',
      description:
        'Frequently asked questions about our services and processes',
    },
    '/contact': {
      title: 'Contact Us',
      description: 'Get in touch with our team at Hoptira',
    },
    '/privacy-policy': {
      title: 'Privacy Policy',
      description:
        'Learn how we collect, use, and protect your personal information',
    },
    '/terms': {
      title: 'Terms & Conditions',
      description:
        'Please read these terms carefully before using our services',
    },
    '/sitemap': {
      title: 'Sitemap',
      description: 'Find all the pages available on our website',
    },
    '/404': {
      title: 'Page Not Found',
      description: 'The page you are looking for could not be found',
    },
  },
  // Function to handle dynamic service pages
  getServiceMeta: (serviceName: string) => ({
    title: `${serviceName} Services`,
    description: `Learn more about our ${serviceName.toLowerCase()} services and solutions`,
  }),
};

export default titleConfig;
